import { useDispatch, useSelector, useStore } from "react-redux";
import { badgeOrdersSelector } from "../../../redux/eventEdition/selectors/eventEdition.selectors";
import { BadgeOrder } from "../../../redux/types";
import { RootState } from "../../../redux/store";
import { setBadgeOrders } from "../../../redux/eventEdition/slice/eventEditionSlice";

export const useBadgeOrders = () => {
  const dispatch = useDispatch();
  const orders: BadgeOrder[] = useSelector(badgeOrdersSelector);
  const { getState } = useStore();

  const getOrdersByBadgeId = (badgeId: string) => {
    return orders.filter(order => order.badgeId === badgeId);
  };

  const updateBadgeOrder = (badgeOrder: BadgeOrder) => {
    const existingOrder = orders.find(o => o.badgeId === badgeOrder.badgeId);
    if (existingOrder) {
      const updatedOrders = orders.map(o => (o.badgeId === badgeOrder.badgeId && o.createdDate ? badgeOrder : o));
      dispatch(setBadgeOrders(updatedOrders));
      return;
    }
    dispatch(setBadgeOrders([...orders, badgeOrder]));
  };

  const addNewOrder = (newOrder: BadgeOrder) => {
    const store = getState() as RootState;
    dispatch(setBadgeOrders([...store.eventEdition.orders, newOrder]));
  };

  return { getOrdersByBadgeId, updateBadgeOrder, addNewOrder };
};
